// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Icon_wrapper__1ZTCV","noBackground":"Icon_noBackground__1Sl-G","sm":"Icon_sm__16KBW"};